<script lang="ts" setup>
import { VueFinalModal } from 'vue-final-modal';

defineProps<{
  title?: string;
  confirmBtnIcon?: string;
  confirmBtnText?: string;
  cancelBtnText?: string;
  isHideCloseBtn?: boolean;
  isLoading?: boolean;
}>();

defineEmits(['before-open', 'opened', 'close', 'click-outside', 'confirm', 'cancel']);
</script>

<template>
  <VueFinalModal
    class="base-modal__wrapper"
    content-class="base-modal__content"
    content-transition="vfm-slide-down"
    overlay-transition="vfm-fade"
    @closed="$emit('close')"
    @opened="$emit('opened')"
    @before-open="$emit('before-open')"
    @click-outside="$emit('click-outside')"
  >
    <section
      :class="{ '!p-0': !title }"
      class="flex justify-center gap-4 -mx-3 p-3 bg-white sticky top-0 z-10"
    >
      <h2
        v-if="title"
        class="text-center px-10"
        v-html="title"
      />

      <button
        v-if="!isHideCloseBtn"
        class="base-modal__close-btn"
        name="close-modal"
        @click="$emit('close')"
      >
        <SvgoCross
          :font-controlled="false"
          class="size-7"
          filled
        />
      </button>
    </section>

    <section class="overflow-auto py-1">
      <slot />
    </section>

    <div
      v-if="cancelBtnText || confirmBtnText"
      class="flex gap-4 -mx-3 p-3 bg-white sticky bottom-0"
    >
      <TheBtn
        v-if="cancelBtnText"
        :is-loading="isLoading"
        class="w-full"
        color="secondary"
        size="md"
        @click="$emit('cancel')"
      >
        {{ cancelBtnText }}
      </TheBtn>

      <TheBtn
        v-if="confirmBtnText"
        :is-loading="isLoading"
        :prepend-icon="confirmBtnIcon"
        class="w-full"
        size="md"
        @click="$emit('confirm')"
      >
        {{ confirmBtnText }}
      </TheBtn>
    </div>
  </VueFinalModal>
</template>

<style lang="scss">
.base-modal {
  &__wrapper {
    @include screen-sm {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  &__content {
    position: fixed;
    bottom: 0;
    display: flex;
    flex-direction: column;
    gap: 12px;
    overflow-y: hidden;
    width: 100%;
    max-width: 900px;
    max-height: 96%;
    padding: 0 12px;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    background-color: $white;

    @include screen-sm {
      position: relative;
      width: fit-content;
      margin: 0 16px;
      border-radius: 12px;
    }
  }

  &__close-btn {
    position: absolute;
    top: 12px;
    right: 12px;
    border-radius: 6px;
    background-color: $white;
    color: $hell-black-60;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      background-color: $hell-black-5;
      color: $hell-black;
    }
  }
}
</style>
